﻿import * as React from "react";
import { Icon } from "../Components";
import { Utils } from "../../Utilities";

export interface ILoadingProps {
    /**
     * A CSS class to add to the loading container
     */
    className?: string;

    /**
     * A CSS class to pass to the loading icon element itself
     */
    iconClassName?: string;

    /**
     * The optional forced height of the icon
     */
    iconHeight?: number;

    /**
     * A custom url to use for the loading icon.
     */
    iconUrl?: string;

    /**
     * The optional forced width of the icon
     */
    iconWidth?: number;
}

export const Loading: React.FunctionComponent<ILoadingProps> = (
    props,
): React.ReactElement => {
    const className = `smarttools-loading-container ${
            props.className ? props.className : ``
        }`,
        iconClassName = `smarttools-loading ${
            props.iconClassName ? props.iconClassName : ``
        }`,
        iconHeight: number = Utils.isNumber(props.iconHeight)
            ? props.iconHeight
            : null,
        iconWidth: number = Utils.isNumber(props.iconWidth)
            ? props.iconWidth
            : null,
        url: string = props.iconUrl
            ? props.iconUrl
            : `${ROOT_IMAGES_URL}UI/loading_metribird.svg`;

    return (
        <div className={className}>
            <Icon
                className={iconClassName}
                height={iconHeight}
                url={url}
                width={iconWidth}
            />
        </div>
    );
};
